export const fixedProfilesPerAppearanceMainstream = {
  rating1: [264517, 244568, 244466, 261214, 264876, 59494],
  rating2: [276340, 257692, 254650, 252886, 271857, 250182],
  rating3: [248455, 237455, 287691, 247199, 261179, 273131],
  rating4: [294248, 242253, 280453, 292257, 260044, 244188],
  rating5: [237496, 245993, 241951, 288540, 276307, 279711],
  rating6: [237985, 249347, 255951, 284496, 253413, 284716]
}
